import { AccountBalanceHistory } from '@app/models/account-balance-history';
import { AccountType } from '@app/models/account-type';
import { Currency } from '@app/models/currency';
import { SavingAgreement } from "@app/models/saving-agreement";
import { AccountRevaluation } from './account-revaluation';

export class Account {
  id: string = "";
  number: string = "";
  status: string = "";
  customerId: string = "";
  customerAccountNumber?: string;
  balance?: number;
  customerFullName?: string;
  currency?: Currency;
  accountType?: AccountType;
  hasPositiveBalance?: boolean;
  accountBalanceHistory?: AccountBalanceHistory;
  accountBalanceHistories: AccountBalanceHistory[] = [];
  branchId?: string;
  currencyId?: string;
  manualEntriesAllowed: boolean;
  accountTypeId: string;
  name?: string;
  glName?: string;
  branchCode?: string;
  branchName?: string;
  created?: string;
  account?: string;
  maxBalance?: number;
  minBalance?: number;
  quantifiable?: boolean;
  accountTypeCode?: string;
  quantity?: number;

  savingAgreementId?: string;
  savingAgreementStatus?: string;
  finalCreditBalance? : number;
  savingAgreement?:SavingAgreement;
  agreement?:SavingAgreement;
  closingDate?: string;
  openDate?: string;
  accountBalanceType? :string;

  accountRevaluation?: AccountRevaluation;
}
